import React from 'react';
import { IRifa } from '../../types/rifa';
import CapaRifa from './CapaRifa';
import PremioRifa from './PremioRifa';
import ContadorRifa from './ContadorRifa';
import CompartilhamentoRifa from './CompartilhamentoRifa';
import GarantiaRifaTech from './GarantiaRifaTech';
import LinksRedesSociais from './LinksRedesSociais';

interface Props {
   rifa: IRifa;
   codigoAfiliacao?: string;
   loading?: boolean;
   numRotacoesFotoPremio?: number;
   numRotacoesFotoOrganizador?: number;
}

const RifaAtiva: React.FC<Props> = ({ rifa, codigoAfiliacao, loading, numRotacoesFotoPremio, numRotacoesFotoOrganizador }: Props) => {
   const [chegouDataSorteio, setChegouDataSorteio] = React.useState<boolean>(false);

   return (
      <div>
         <CapaRifa
            rifa={rifa}
            codigoAfiliacao={codigoAfiliacao}
            loading={loading}
            numRotacoes={numRotacoesFotoOrganizador}
            chegouDataSorteio={chegouDataSorteio}
         />
         <LinksRedesSociais
            linkFacebook={rifa.facebookOrganizador}
            linkInstagram={rifa.instagramOrganizador}
         />
         <PremioRifa rifa={rifa} numRotacoes={numRotacoesFotoPremio} />
         <ContadorRifa
            dataEncerramento={rifa.dataEncerramento}
            onChegouDataSorteio={(chegou: boolean) => setChegouDataSorteio(chegou)}
         />
         <CompartilhamentoRifa numeroRifa={rifa.numeroRifa} />
         <GarantiaRifaTech />
      </div>
   );
};

export default RifaAtiva;
